import { DEFAULT_THEME } from './theme.default';

export const OCEAN_THEME = {
  name: 'ocean',
  base: 'default',
  variables: {
    // keep all default layout variables intact
    ...DEFAULT_THEME.variables,

    // color / visual overrides (override only what you need)
    // adjust these values to tune the ocean look
    'color-primary-100': '#e6f3ff',
    'color-primary-500': '#1e90ff',
    'color-primary-700': '#0066cc',

    // example nested overrides while preserving defaults
    echarts: {
      ...DEFAULT_THEME.variables.echarts,
      bg: '#f5f9fc',
      textColor: '#003366',
      axisLineColor: '#0066cc',
    },

    chartjs: {
      ...DEFAULT_THEME.variables.chartjs,
      axisLineColor: '#0099ff',
      textColor: '#003366',
    },

    // copy any other custom nested objects you need from your previous ocean theme,
    // but always spread DEFAULT_THEME.variables.<section> first to avoid missing keys
  },
};